import { lazy } from 'react';
import { Route } from 'react-router-dom';

const Invites = lazy(() => import('./invites/invites.component').then((module) => ({ default: module.Invites })));

export function ApplicationManageOrganizationRoutes() {
    return (
        <Route path='organization'>
            <Route
                path='invites'
                element={<Invites />}
            />
        </Route>
    );
}
